import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal'
//import Button from 'react-bootstrap/Button'
import { confirmable } from 'react-confirm';

const Confirmation = ({
  okLabel = 'Yes',
  cancelLabel = 'No',
  title = 'Confirmation',
  confirmation,
  show,
  proceed,
  enableEscape = true,
}) => {
  console.log("confirmation", confirmation)
  return (
    <div className="static-modal">
      <Modal animation={false} show={show} onHide={() => proceed(false)} backdrop={enableEscape ? true : 'static'} keyboard={enableEscape}>
        <Modal.Body>
          {confirmation}
          <hr />
          <div className="text-end">
            <button className="btn btn-sm cancel-button me-2" onClick={() => proceed(false)}>{cancelLabel}</button>
            <button className="btn btn-sm confirm-button" onClick={() => proceed(true)}>{okLabel}</button>
          </div>
        </Modal.Body>
        {/*<Modal.Footer>*/}
          
        {/*</Modal.Footer>*/}
      </Modal>
    </div>
  )
}

Confirmation.propTypes = {
  okLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  title: PropTypes.string,
  confirmation: PropTypes.string,
  show: PropTypes.bool,
  proceed: PropTypes.func,     // called when ok button is clicked.
  enableEscape: PropTypes.bool,
}

export default confirmable(Confirmation);